
import React from "react";
import AskQuestionForm from "./ask-question-form";

const AskQuestionContent = () => {
  return (
    <div className="flex-1 bg-gradient-to-b from-[#FDF8FF] to-[#EEDDF8]">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h1 className="text-3xl md:text-4xl font-bold text-[#3D2A60] mb-4">Ask Us Anything</h1>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Have a question or need assistance? We're here to help! Fill out the form below, and our team will get back to you as soon as possible.
            </p>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm border border-solid border-gray-100 p-6 md:p-8">
            <AskQuestionForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AskQuestionContent;
